export default "__VITE_ASSET__VPSAIMo4__"